export const Language = {
  EN: 'en',
  FR: 'fr'
}

export const HomeURL = {
  EN: '/en',
  FR: '/'
}

export const Socials = {
  Twitter: 'twitter',
  Insta: 'instagram',
  Facebook: 'facebook',
  LinkedIn: 'linkedin',
  Link: 'link'
}

export const addScript = url => {
  const script = document.createElement("script")
  script.src = url
  script.async = true
  document.body.appendChild(script)
}

export const handleNetlifyIdentity = () => {
  window.onload = () => {
    addScript("https://identity.netlify.com/v1/netlify-identity-widget.js")
  }
  
  if (window.netlifyIdentity) {
    window.netlifyIdentity.on("init", user => {
      if (!user) {
        window.netlifyIdentity.on("login", () => {
          document.location.href = "/admin/"
        });
      }
    })
  }
}